/* eslint-disable @typescript-eslint/no-explicit-any */
import api from './api';

export interface WebhookPayload {
  event: string;
  payload: any;
}

interface CustomerInfo {
  id: string;
  name: string;
  whatsapp: string;
}

interface PlanInfo {
  id: string;
  name: string;
  price: number;
  billingCycle: 'annual' | 'monthly';
}

export const WebhookService = {
  dispatchFireAndForget(event: string, payload: any): void {
    api.post('/webhooks/dispatch', { event, payload }).catch(console.error);
  },

  async dispatchWebhook(event: string, payload: any): Promise<void> {
    try {
      await api.post('/webhooks/dispatch', {
        event,
        payload,
      });
    } catch (error) {
      console.error('Erro ao disparar webhook:', error);
      throw error;
    }
  },

  async dispatchCartAbandoned(
    customer: {
      name: string;
      email: string;
      whatsapp: string;
    },
    plan: any,
    referralCode?: string | null,
  ): Promise<void> {
    await this.dispatchWebhook('cart_abandoned', {
      customer,
      plan,
      referralCode,
      timestamp: new Date().toISOString(),
    });
  },

  dispatchCheckoutPersonalDataCompleted(customer: CustomerInfo, plan: PlanInfo): void {
    this.dispatchFireAndForget('checkout_personal_data_completed', {
      customer,
      plan,
      timestamp: new Date().toISOString(),
    });
  },

  dispatchCheckoutChildrenDataCompleted(customer: CustomerInfo, plan: PlanInfo, children: any[]): void {
    this.dispatchFireAndForget('checkout_children_data_completed', {
      customer,
      plan,
      children,
      timestamp: new Date().toISOString(),
    });
  },

  // Funil 1 (n8n): filhos + cidade/UF saem daqui, do que a pessoa digitou no
  // checkout — o backend não consulta mais o banco nessa rota pública (#223).
  dispatchCheckoutAddressCompleted(
    customer: CustomerInfo,
    plan: PlanInfo,
    children: { name: string; birthDate?: string }[],
    location: { cidade?: string; estado?: string },
  ): void {
    this.dispatchFireAndForget('checkout_address_completed', {
      customer,
      plan,
      // Mesma ordem que o backend usava (birthdate ASC, sem data por último).
      children: children
        .map((c) => ({ name: c.name, birthdate: c.birthDate || null }))
        .sort((a, b) => (a.birthdate ?? '\uffff').localeCompare(b.birthdate ?? '\uffff')),
      city: location.cidade || null,
      state: location.estado || null,
      timestamp: new Date().toISOString(),
    });
  },

  dispatchCheckoutEmailConfirmed(customer: CustomerInfo, plan: PlanInfo): void {
    this.dispatchFireAndForget('checkout_email_confirmed', {
      customer,
      plan,
      timestamp: new Date().toISOString(),
    });
  },
};
